// extracted by mini-css-extract-plugin
module.exports = {"status":"error_status__CC71O","smaller":"error_smaller__9T7Mp","describe":"error_describe__3dkDP"};